module.exports = __webpack_public_path__ + "static/media/headset.18c044ab.svg";